angular.module('impactx.vcatalog').controller('VCatalogListCtrl', [
    'selectedListItems',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'ShopViewService',
    '$scope',
    'DownloadService',
    'AppConfiguration',
    'ListHelperService',
    VCatalogListCtrl]);

function VCatalogListCtrl(selectedListItems, dataGen, ToastService, $mdDialog, ShopViewService, $scope, DownloadService, AppConfiguration, ListHelperService) {

    var self = this;
    var enablePRGDialog = AppConfiguration.get('enableCatalogToViewCopy');

    this.getDetailLink = function() {
        return "vcatalogedit/" + selectedListItems.getFirstSelectedId();
    };

    this.getRightsLink = function() {
        return "vcatalogeditrights/" + selectedListItems.getFirstSelectedId();
    };

    this.getCatalogReplaceLink = function() {
        return "catalogreplace";
    };

    this.getMeta = function() {
        return this.meta;
    };

    this.getPrintToken = function() {
        if (selectedListItems.isSingleSelection()) {
            var item = selectedListItems.getFirstSelectedItem();
            return item && item.printTokens && item.printTokens.vcat ? item.printTokens.vcat : null;
        }
        return null;
    };

    this.addToQueue = function () {
        dataGen.postAsForm({}, {vcatId: selectedListItems.getFirstSelectedId()}, "/vcatalog/addToQueue").then(function (data) {
            ToastService.openStandardToast(impactX.isDefined(data, "trns.successMessage"));
        })
    };

    this.exportAllDialog = function (event) {
        $mdDialog.show({
            templateUrl: 'modules/vcatalog/templates/vcatalog.exportsettings.html',
            controller: "VCatalogExportSettingsCtrl",
            controllerAs: "vCatalogExportSettingsCtrl",
            targetEvent: event,
            clickOutsideToClose: true,
            escapeToClose: false,
            bindToController: true,
            locals: {
                optionsEntrypoint: '/vcatalog/exportallview',
                exportEntrypoint: '/vcatalog/exportall',
                vcatId: 0
            }
        }).then(function () {

        });
    };

    this.canViewShopLink = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().amountProducts &&
            selectedListItems.getFirstSelectedItem().amountProducts > 0 && selectedListItems.getFirstSelectedItem().hasRightToViewShop.value;
    };

    this.activateShopView = function() {
        var item = selectedListItems.getFirstSelectedItem();
        ShopViewService.activateShopView({id: item.id, sourcePath: "vcataloglist"});
    };

    this.canExportOrImportView = function () {
        return selectedListItems.isSingleSelection() && AppConfiguration.get("enableCatalogToViewCopy")
            && !selectedListItems.getFirstSelectedItem().hasOriginalCatalog.value;
    };

    this.exportView = function () {
        DownloadService.openDownloadPost('/vcatalog/exportview', {paramName: "id", paramValue: selectedListItems.getFirstSelectedId()});
    };

    this.canResetEditUser = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canResetEditUser.value;
    };

    this.resetEditUser = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm({}, {vcatId: selectedListItems.getFirstSelectedId()}, "/catalogeditor2/edit/end").then(function (data) {
            ToastService.openStandardToast(impactX.isDefined(data, "trns.successMessage"));
            ListHelperService.refreshListData($scope, 'vcatalogListCtrl', {unselectRows: selectedItems});
        })
    };

    this.importView = function (event, trns) {
        $mdDialog.show({
            controller: "VCatalogViewImportCtrl",
            controllerAs: "vCatalogViewImportCtrl",
            templateUrl: "modules/vcatalog/templates/vcatalog-importview.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                trns: trns,
                vCatId: selectedListItems.getFirstSelectedId()
            }
        });
    };

    this.getPRGDialogLink = function () {
        return 'editvcatproductgroups/' + selectedListItems.getFirstSelectedId();
    };

    this.canViewProductGroups = function () {
        return enablePRGDialog && selectedListItems.isSingleSelection()
            && selectedListItems.getFirstSelectedItem().enablePRGDialog.value;
    };

    var buttonDefinition = [
        {label: "exportAll", action: self.exportAllDialog, condition: selectedListItems.isNoSelection, process: 'VCatalogExportAll'},
        {label: "catalogReplace", linkFunction: self.getCatalogReplaceLink, type:'link', condition: selectedListItems.isNoSelection, process: 'CatalogReplace'},
        {label: "details", linkFunction: self.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'VCatalog'},
        {label: "rights", linkFunction: self.getRightsLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'VCatalog'},
        {label: "shopView", action: self.activateShopView, condition: self.canViewShopLink, process: 'Search'},
        {label: "productGroups", linkFunction: self.getPRGDialogLink, type: 'link', condition: self.canViewProductGroups, process: 'VCatalog'},
        {
            label: "printCatalog",
            type:'print',
            condition: selectedListItems.isSingleSelection,
            process: 'VCatalog',
            params: {
                printTokenFunction: self.getPrintToken
            }
        },
        {label: "index", action: self.addToQueue, condition:  selectedListItems.isSingleSelection, process: 'IndexVcat'},
        {label: "exportView", action: self.exportView, condition: self.canExportOrImportView, process: 'VCatalog'},
        {label: "importView", action: self.importView, condition: self.canExportOrImportView, process: 'VCatalog'},
        {label: "resetEditUser", action: self.resetEditUser, condition: self.canResetEditUser, process: ''}
    ];

    this.meta = {
        rowTemplate: 'modules/vcatalog/templates/vcatalog.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/vcatalog/list',
        ctrl: this,
        id: "vcataloglist",
        mainAction : {id:"new", link: "#/vcatalogedit/0", icon:"mdi-plus"},
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
}
